import { ProtectedPage } from "@/components/misc/protected";
import { ReviewGridPage } from "@/routes/draft-experiments/-lib/review.page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/draft-experiments/$id/review/")({
  component: () => (
    <ProtectedPage requires="org:draft_experiments:review_read">
      <ReviewGridPage />
    </ProtectedPage>
  ),
});
